module.exports = __webpack_public_path__ + "img/plan.9984ae10.svg";